import { useQuery } from "@tanstack/react-query";
import * as API from "../../networking/risk";
import { Risk } from "../../redux/reducers/types/commonTypes";

export const useUserRisks = () => {
    return useQuery<Risk[]>({
        queryKey: ["risks", "user"],
        queryFn: async () => {
            const response = await API.getRisksForUser();
            // Transform the response to match the expected format
            // The API returns an array, but we need to group by policy
            const risks = response.data;
            return risks;
        },
    });
};

export const usePolicyRisks = (policyId: number) => {
    return useQuery<Risk[]>({
        queryKey: ["risks", "policy", policyId],
        queryFn: async () => {
            const response = await API.getRisksForPolicy(policyId);
            return response.data;
        },
        enabled: !!policyId,
    });
};

